// extracted by mini-css-extract-plugin
module.exports = {"ementas_digitais":"LanguageItems_ementas_digitais__2-2bX","LanguageItems":"LanguageItems_LanguageItems__eouI6","chef_house":"LanguageItems_chef_house__t7Fj2"};